import React, { useEffect, useState } from "react";
import { Image, Link } from "@nextui-org/react";
import { AiOutlineClockCircle, AiOutlineEye } from "react-icons/ai";
import { useRouter } from "next/router";

import SharedServiceInstance from "@/services/shared-service";
import PostMoreBlock from "@/components/shared/post-more-block";
import { GlobalSettings } from "@/configuration/global-settings";

var _ = require('lodash');
import moment from 'moment';
import { FaHashtag } from "react-icons/fa6";
import YoutubePlaylistEmbed from "@/components/shared/youtube-playlist-embed";
import {CATEGORY_PLAYLIST_MAP} from "@/components/helpers/constant";

export default function NewsCategoryBlock(params) {
    const router = useRouter();
    const tagCode = router.query?.id
    const categoryStatic = params?.caterogyStatic || '';
    const categoryData = params.categoryData;
    const sharedService = SharedServiceInstance;
    const [videos, setVideos] = useState([]);
    const categoryID = router.query['news-cate-code'];
    const [playlistId, setPlaylistId] = useState(null);

    const fetchPlaylist = async (categoryID) => {
        const matched = CATEGORY_PLAYLIST_MAP.find(item => item.categoryID === categoryID);
        if (matched?.playlistId) {
            setPlaylistId(matched?.playlistId);
            const res = await fetch(`/api/youtube-playlist?list=${matched.playlistId}`);
            const data = await res.json();
            setVideos(data?.items || []);
        } else {
            setVideos([]);
        }
    };

    useEffect(() => {
        if (categoryID) {
            fetchPlaylist(categoryID).then(r => {});
        }
    }, [categoryID]);

    return <>
        <div className="w-full">
            <h2 className="font-bold text-5xl pt-5 text-center sm:text-left px-2 text-primary">{categoryStatic?.name || categoryStatic?.name}</h2>
            {tagCode && (
                <div className="text-[#a7b2c0] flex text-3xl text-primary">
                    <FaHashtag className="my-auto mx-2 text-[20px]" />
                    <span>{tagCode}</span>
                </div>
            )}

            <div className="sm:grid sm:grid-cols-1 md:grid-cols-4 my-5 gap-4 px-2 sm:sm-0">
                <div className="sm:col-span-3 bg-white px-3">
                    {videos?.length > 0 && <YoutubePlaylistEmbed data={videos} playlistId={playlistId}/>}
                    <div>
                        {categoryData.value.map((categoryData, index) => {
                            return <>
                                <div key={index} className="sm:grid sm:grid-cols-3 sm:gap-5 py-3">
                                    <div className="sm:col-span-1 min-h-[100px] flex items-center justify-center">
                                        <Image
                                            alt={categoryData?.title} className="rounded-none object-cover aspect-video"
                                            src={sharedService.isValidUrl(categoryData?.photo) ? `${sharedService.getOptimizeImage(categoryData?.photo, "main-post-view")}` : categoryData?.photo ? `${GlobalSettings.Settings.Server_New}/${categoryData?.photo}` : "/images/Pic_3.png"}
                                        />
                                    </div>

                                    <div className="sm:col-span-2 text-news pt-3 sm:pt-0">
                                        <div className="flex xl:pt-3 py-auto text-xs">
                                            {categoryData?.publishDate && <>
                                                <p className="inline-block my-auto">
                                                    <AiOutlineClockCircle className="mr-2"/>
                                                </p> {moment(categoryData?.publishDate).format('DD/MM/YYYY')}
                                            </>}
                                            <p className="inline-block my-auto pl-5">
                                                <AiOutlineEye className="mr-2"/>
                                            </p> {categoryData?.visit || 0}

                                            <p className="inline-block my-auto pl-5">{_.head(categoryData?.categories)?.name}</p>
                                        </div>

                                        <Link href={sharedService.getPostPath(categoryData)}>
                                            <h5 className="text-2xl text-news font-bold line-clamp-2 my-1">{categoryData?.title}</h5>
                                        </Link>

                                        <p className="text-xl italic line-clamp-3">{categoryData?.metaDescription}</p>
                                    </div>
                                </div>
                            </>
                        })}
                    </div>
                </div>
                
                <div className="posts-categories--more hidden md:block">
                    <PostMoreBlock categoryID={categoryStatic?.code} />
                </div>
            </div>
        </div>
    </>
}
